import {Component, inject, OnInit} from '@angular/core';
import {FileDetailService, TransactionHistoryType, TransactionsComponent} from '|shared';
import {EsslObjectType} from '|api/commons';
import {AsyncPipe} from '@angular/common';

@Component({
  selector: 'icz-file-detail-history',
  templateUrl: './file-detail-history.component.html',
  styleUrls: ['./file-detail-history.component.scss'],
  imports: [TransactionsComponent, AsyncPipe]
})
export class FileDetailHistoryComponent implements OnInit {

  private fileDetailService = inject(FileDetailService);

  file$ = this.fileDetailService.object$;

  ngOnInit() {
    this.fileDetailService.showSubmitBar = false;
  }

	protected readonly EsslObjectType = EsslObjectType;
  protected readonly TransactionHistoryType = TransactionHistoryType;

}
